
import { defineComponent, reactive, watch } from "vue";
import moment from "moment";
import { convertToMoney } from "@/utils/stringUtils";
interface Data {
  cThang: string | null;
  nSanLuong: number | null;
  nThanhTien: number | null;
  nTongTien: number | null;
  nVat: number | null;
}
export default defineComponent({
  name: "kt-widget-1",
  props: {
    dataString: String,
    widgetClasses: String,
  },
  setup(props) {
    const data = reactive<Data>(JSON.parse(props.dataString as string));
    watch(
      () => props.dataString,
      (newData) => {
        Object.assign(data, JSON.parse(newData as string));
      }
    );
    return {
      data,
    };
  },
  methods: {
    handleDate(date: string) {
      return moment(date).format("DD/MM/YYYY");
    },
    handleNumber(val) {
      return convertToMoney(val);
    },
  },
});
